import React, { useState, useCallback, Suspense } from "react";
import { Route, Redirect, Switch } from "react-router-dom";

import Layout from "./components/layout/Layout";

import StartingPage from "./components/pages/StartingPage";
// import Page1 from "./components/questions/Page1";
// import Page2 from "./components/questions/Page2";
// import Page3 from "./components/questions/Page3";
// import Page4 from "./components/questions/Page4";
// import Page5 from "./components/questions/Page5";
// import Page5Test from "./components/questions/Page5Test";
// import Page6 from "./components/questions/Page6";
// import Page7 from "./components/questions/Page7";
// import Page8 from "./components/questions/Page8";
// import Page9 from "./components/questions/Page9";
// import Page10 from "./components/questions/Page10";
// import Page11 from "./components/questions/Page11";
// import ReminderPage from "./components/pages/ReminderPage"; // page12
// import Page13 from "./components/questions/Page13";
// import Page14 from "./components/questions/Page14";
// import Page15 from "./components/questions/Page15";
// import Page16 from "./components/questions/Page16";
// import Page17 from "./components/questions/Page17";
// import Page18 from "./components/questions/Page18";
// import Page19 from "./components/questions/Page19";
import SurveyResultPage from "./components/pages/SurveyResultPage";
import NotFoundPage from "../src/components/pages/NotFoundPage";

import { RegisterContext } from "./components/context/register-context";
import { ProgressContext } from "./components/context/progress-context";
import LoadingSpinner from "./components/UI/LoadingSpinner";

const Page1 = React.lazy(() => import("./components/questions/Page1"));
const Page2 = React.lazy(() => import("./components/questions/Page2"));
const Page3 = React.lazy(() => import("./components/questions/Page3"));
const Page4 = React.lazy(() => import("./components/questions/Page4"));
const Page5Test = React.lazy(() => import("./components/questions/Page5Test"));
const Page6 = React.lazy(() => import("./components/questions/Page6"));
const Page7 = React.lazy(() => import("./components/questions/Page7"));
const Page8 = React.lazy(() => import("./components/questions/Page8"));
const Page9 = React.lazy(() => import("./components/questions/Page9"));
const Page10 = React.lazy(() => import("./components/questions/Page10"));
const Page11 = React.lazy(() => import("./components/questions/Page11"));
const ReminderPage = React.lazy(() => import("./components/pages/ReminderPage"));
const Page13 = React.lazy(() => import("./components/questions/Page13"));
const Page14 = React.lazy(() => import("./components/questions/Page14"));
const Page15 = React.lazy(() => import("./components/questions/Page15"));
const Page16 = React.lazy(() => import("./components/questions/Page16"));
const Page17 = React.lazy(() => import("./components/questions/Page17"));
const Page18 = React.lazy(() => import("./components/questions/Page18"));
const Page19 = React.lazy(() => import("./components/questions/Page19"));

function App() {
  const [isRegistered, setIsRegistered] = useState(false);
  const [userId, setUserId] = useState(false);
  const [percentage, setPercentage] = useState(0);

  const register = useCallback((uid) => {
    setIsRegistered(true);
    setUserId(uid); // Get userId from backend when the user is created
  }, []);

  const unregister = useCallback(() => {
    setIsRegistered(false);
    setUserId(null);
  }, []);

  const nextBtn = useCallback(() => {
    setPercentage((prePercentage) => prePercentage + 5.3);
  }, []);

  const nextBtnInvalidInput = useCallback(() => {
    setPercentage((prePercentage) => prePercentage + 0);
  }, []);

  const resetProgress = useCallback(() => {
    setPercentage(0);
  }, []);

  return (
    <RegisterContext.Provider
      value={{
        isRegistered: isRegistered,
        userId: userId,
        register: register,
        unregister: unregister,
      }}
    >
      <ProgressContext.Provider
        value={{
          percentage: percentage,
          nextBtn: nextBtn,
          nextBtnInvalidInput: nextBtnInvalidInput,
          resetProgress: resetProgress,
        }}
      >
        <Layout>
          <Suspense fallback={<div className="centered"><LoadingSpinner /></div>}>
            <Switch>
              <Route path="/" exact>
                <StartingPage />
              </Route>
              <Route path="/surveyresultpage/:userId" exact>
                <SurveyResultPage />
              </Route>
              <Route path="/page1" exact>
                <Page1 />
              </Route>
              <Route path="/page2" exact>
                <Page2 />
              </Route>
              <Route path="/page3" exact>
                <Page3 />
              </Route>
              <Route path="/page4" exact>
                <Page4 />
              </Route>
              <Route path="/page5" exact>
                <Page5Test />
              </Route>
              <Route path="/page6" exact>
                <Page6 />
              </Route>
              <Route path="/page7" exact>
                <Page7 />
              </Route>
              <Route path="/page8" exact>
                <Page8 />
              </Route>
              <Route path="/page9" exact>
                <Page9 />
              </Route>
              <Route path="/page10" exact>
                <Page10 />
              </Route>
              <Route path="/page11" exact>
                <Page11 />
              </Route>
              <Route path="/page12" exact>
                <ReminderPage />
              </Route>
              <Route path="/page13" exact>
                <Page13 />
              </Route>
              <Route path="/page14" exact>
                <Page14 />
              </Route>
              <Route path="/page15" exact>
                <Page15 />
              </Route>
              <Route path="/page16" exact>
                <Page16 />
              </Route>
              <Route path="/page17" exact>
                <Page17 />
              </Route>
              <Route path="/page18" exact>
                <Page18 />
              </Route>
              <Route path="/page19" exact>
                <Page19 />
              </Route>
              <Redirect to="/" />
              <Route path="*">
                <NotFoundPage />
              </Route>
            </Switch>
          </Suspense>
        </Layout>
      </ProgressContext.Provider>
    </RegisterContext.Provider>
  );
}

export default App;
